import {isNil, isNotNil} from 'ramda';

import {useGetServiceOrderMandatoryFieldsQuery} from '@dms/api/workshop';
import {LevelIndicator, type OrderStateType} from '@dms/shared';

import {Nullish} from 'shared/web';

import {getLevelAwareFieldRequired} from '../../../../../utils/getLevelAwareFieldRequired';

// Any state not listed here is treated as opened, so an unknown state keeps the
// full set of mandatory fields instead of silently dropping validation.
const SERVICE_ORDER_STATES_BEFORE_OPENING: readonly OrderStateType[] = [
  'DRAFT',
  'REQUEST',
  'OFFER',
];

const isServiceOrderBeforeOpening = (state: OrderStateType | Nullish) =>
  isNotNil(state) && SERVICE_ORDER_STATES_BEFORE_OPENING.includes(state);

export function useOrderMandatoryFields(
  serviceOrderId: string,
  serviceOrderState: OrderStateType | Nullish,
  levelIndicators: LevelIndicator[]
) {
  const {currentData, isFetching, isError} = useGetServiceOrderMandatoryFieldsQuery({
    serviceOrderId,
    event: isServiceOrderBeforeOpening(serviceOrderState) ? 'BEFORE_OPENING' : undefined,
  });

  const isFieldRequired = getLevelAwareFieldRequired(
    (name) => !!currentData?.mandatoryFields?.includes(name),
    levelIndicators
  );

  return {
    data: currentData,
    isLoading: isFetching && isNil(currentData),
    isError,
    isFieldRequired,
  };
}
